<div
    class="relative"
    [hidden]="hidden">
    <div
        *ngIf="iframeLoading"
        class="absolute top-0 left-0 h-full w-full z-10 bg-white/60 backdrop-blur-lg flex items-center justify-center">
        <mat-spinner></mat-spinner>
    </div>
    <div
        *ngIf="internalIframeLoading"
        class="absolute left-1/2 top-4 -translate-x-1/2 z-[999999] p-2 bg-white rounded-lg shadow-lg">
        <mat-spinner diameter="30"></mat-spinner>
    </div>
    <iframe
        #myIframe
        class="h-[calc(100vh-65px)]"
        [ngClass]="{
            'small-zoom10': zoomLevelService.zoomLevel === '10%' && smallZoom,
            'small-zoom20': zoomLevelService.zoomLevel === '20%' && smallZoom,
            'small-zoom30': zoomLevelService.zoomLevel === '30%' && smallZoom,
            'small-zoom40': zoomLevelService.zoomLevel === '40%' && smallZoom,
            'small-zoom50': zoomLevelService.zoomLevel === '50%' && smallZoom,
            'small-zoom60': zoomLevelService.zoomLevel === '60%' && smallZoom,
            'small-zoom70': zoomLevelService.zoomLevel === '70%' && smallZoom,
            'small-zoom80': zoomLevelService.zoomLevel === '80%' && smallZoom,
            'small-zoom90': zoomLevelService.zoomLevel === '90%' && smallZoom
        }"
        *ngIf="iFrameSrc"
        frameBorder="0"
        [src]="iFrameSrc"
        (load)="iFrameLoaded(myIframe)"></iframe>
</div>
